import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mx-auto w-full max-w-[400px]',
    title: 'heading-2xl lg:heading-3xl mb-2',
    description: 'heading-s mb-8',
    button: 'mt-12 w-full'
  }
});
